// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.OWyfVsolvMqybUZeByaQ {
  padding-top: 60px;
  padding-bottom: 60px;
}

.OWyfVsolvMqybUZeByaQ h1 {
  max-width: 900px;
  margin-bottom: 40px;
  line-height: 1.1em;
  font-size: 50px;
}

.efIZrOOcjwhAfoVrGefs {
  font-size: 18px;
}

@media (max-width: 695px) {
  .OWyfVsolvMqybUZeByaQ h1 {
    font-size: 23px;
    margin: 16px 0 21px 0;
  }

  .efIZrOOcjwhAfoVrGefs {
    font-size: 15px;
  }
}

.ONar0fVl9UGyH21DXSkE {
  margin-bottom: 32px;
  color: gray;
}

.ni6Ntt0TcO5kPOdvfQmA {
  font-weight: 600;
  font-size: 27px;
  margin-bottom: 21px;
}`, "",{"version":3,"sources":["webpack://./src/pages/demo/demo.module.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE;IACE,eAAe;IACf,qBAAqB;EACvB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,mBAAmB;AACrB","sourcesContent":[".demoContainer {\n  padding-top: 60px;\n  padding-bottom: 60px;\n}\n\n.demoContainer h1 {\n  max-width: 900px;\n  margin-bottom: 40px;\n  line-height: 1.1em;\n  font-size: 50px;\n}\n\n.desc {\n  font-size: 18px;\n}\n\n@media (max-width: 695px) {\n  .demoContainer h1 {\n    font-size: 23px;\n    margin: 16px 0 21px 0;\n  }\n\n  .desc {\n    font-size: 15px;\n  }\n}\n\n.disclaimer {\n  margin-bottom: 32px;\n  color: gray;\n}\n\n.date {\n  font-weight: 600;\n  font-size: 27px;\n  margin-bottom: 21px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"demoContainer": `OWyfVsolvMqybUZeByaQ`,
	"desc": `efIZrOOcjwhAfoVrGefs`,
	"disclaimer": `ONar0fVl9UGyH21DXSkE`,
	"date": `ni6Ntt0TcO5kPOdvfQmA`
};
export default ___CSS_LOADER_EXPORT___;
